<section class="cp-section" [id]="'sec-' + sectionKey" [attr.data-section]="sectionKey">
  <header class="cp-head">
  <h2 class="cp-h2" [style.border-color]="accent">{{ title }}</h2>
  <p class="cp-section-lead" *ngIf="lead">{{ lead }}</p>
  </header>
  <div class="cp-main">

  <div class="ta-about" *ngIf="paragraphs.length">
    <p *ngFor="let p of paragraphs" [innerHTML]="p"></p>
  </div>

  <div class="ta-faq" *ngIf="faq.length">
    <details class="ta-faq-item" *ngFor="let q of faq">
      <summary class="ta-faq-q">{{ q.q }}</summary>
      <p class="ta-faq-a" [innerHTML]="q.a"></p>
    </details>
  </div>
  </div>
</section>

<!-- the tool's ratings and the visitor's own, the very last thing on the page -->
<app-tool-rating *ngIf="ratingKey" [toolKey]="ratingKey" [toolName]="ratingName" [accent]="accent"></app-tool-rating>
